import { z } from 'zod';
import { USER_ROLES } from '../constants/index.js';
import { uuidSchema } from './common.js';
const phoneSchema = z
    .string()
    .trim()
    .regex(/^[+0-9 ()./-]{6,24}$/, { message: 'validation.phone' });
export const createUserSchema = z.object({
    username: z.string().trim().min(3).max(64).regex(/^[a-z0-9._-]+$/, {
        message: 'validation.username',
    }),
    password: z.string().min(8).max(128),
    firstName: z.string().trim().min(1).max(80),
    lastName: z.string().trim().min(1).max(80),
    phone: phoneSchema.optional(),
    role: z.enum(USER_ROLES),
    /**
     * The vehicle this staff member currently drives. Reassignable by the admin;
     * stock stays with the vehicle, so a reassignment moves the driver only.
     */
    vehicleId: uuidSchema.nullish(),
    isActive: z.boolean().default(true),
});
export const updateUserSchema = createUserSchema.partial().omit({ password: true });
export const changePasswordSchema = z.object({
    password: z.string().min(8).max(128),
});
export const userSchema = createUserSchema.omit({ password: true }).extend({
    id: uuidSchema,
    createdAt: z.string(),
    updatedAt: z.string(),
});
//# sourceMappingURL=user.js.map